import React, { Component } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";

import { PieChart } from "../../common/PieChart";
import * as styles from "./PulseItem.scss";

export interface IPulseItemProps extends ITestableComponentProps {
    label: string;
    valueSuffix?: string;
    min?: number;
    max?: number;
    value?: number;
    invertedWarning?: boolean;
    tooltip?: string;
}

export class PulseItem extends Component<IPulseItemProps> {
    public render() {
        const { label, valueSuffix, value, invertedWarning, tooltip } =
            this.props;

        const min = this.props.min || 0;
        const max = this.props.max || 100;
        const valueString = value
            ? `${Math.round(value)}${valueSuffix}`
            : "...";

        const noData = value === undefined;

        return (
            <div
                className={classnames(
                    styles["pulse-item"],
                    noData && styles["no-data"],
                )}
                key={tooltip} // trigger the tooltip to re-render on change
                data-tooltip={tooltip}
                data-testid={this.props["data-testid"]}
            >
                <PieChart
                    className={styles.pie}
                    min={min}
                    max={max}
                    value={value || min}
                    size={26}
                    invertedWarning={invertedWarning}
                />
                {label && <div className={styles.label}>{label}</div>}
                <div className={styles.value}>{valueString}</div>
            </div>
        );
    }
}
